// extracted by mini-css-extract-plugin
export default {"searchContainer":"PISearchContent_searchContainer__5MhpD"};